export default class LanguageCodes {
  static readonly german: string = 'de-CH';
}
